import React, { useState } from 'react'
import HeroSection from '../components/HeroSection'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import { homeObjOne} from '../components/InfoSection/Data'
import InfoSection from '../components/InfoSection'
import Footer from '../components/Footer'
import Gallery from '../components/Gallery'
import Contact from '../components/Contact'
import Photo1 from '../images/DSC_0034.JPG'
import Photo2 from '../images/DSC_0058.JPG'
import Photo3 from '../images/DSC_0059.JPG'
import Photo4 from '../images/DSC_0089.JPG'
import Photo5 from '../images/DSC_0092.JPG'
import Photo6 from '../images/DSC_0094.JPG'
import Photo7 from '../images/DSC_0095.JPG'
import Photo8 from '../images/DSC_0100.JPG'
import Photo9 from '../images/DSC_0102.JPG'
import Photo10 from '../images/DSC_0103.JPG'
import Photo11 from '../images/DSC_0105.JPG'
import Photo12 from '../images/DSC_0107.JPG'


const Home = () => {
  const galleryImages = [
    {
      img: `${Photo1}`
    },
    {
      img: `${Photo2}`
    },
    {
      img: `${Photo3}`
    },
    {
      img: `${Photo4}`
    },
    {
      img: `${Photo5}`
    },
    {
      img: `${Photo6}`
    },
    {
      img: `${Photo7}`
    },
    {
      img: `${Photo8}`
    },
    {
      img: `${Photo9}`
    },
    {
      img: `${Photo10}`
    },
    {
      img: `${Photo11}`
    },
    {
      img: `${Photo12}`
    },
  ]
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
      <Navbar toggle={toggle}/>
      <HeroSection />
      <InfoSection {...homeObjOne}/>
      <Gallery galleryImages={galleryImages}/>
      <Contact />
      <Footer />
    </>
  )
}

export default Home
